<script>
  import TextInput from '../../../../components/inputs/text';
  import AvatarInput from '../../../../components/inputs/avatar';
  import TextAreaInput from '../../../../components/inputs/textarea';
  import CoordinatorInput from '../../../../components/inputs/coordinator';
  import CategoryInput from '../../../../components/inputs/category';
  import AnnualScheduleInput from '../../../../components/inputs/schedule';
  import Form from '../../../../components/inputs/form';
  import SectionNav from '../../../../components/navigation/section';
  import Link from '../../../../utils/link';
  import PhoneNumber from  'awesome-phonenumber';
  import moment from 'moment';

  export let value;
  
  let age = value.birthMonth && value.birthYear ? moment().diff(moment().year(value.birthYear).month(value.birthMonth), 'years') : null;

  function displayPhone() {
    return new PhoneNumber(value.household.primary.user.phone, 'US').getNumber('national');
  }

  function getPrimaryPersonLink() {
    return `/people/view/${value.household.primary.person.id}`;
  }
</script>

<style>
  h2 {
    font-family: proxima-nova, sans-serif;
    color: #4c4c4b;
    font-weight: 500;
    font-size: 13px;
    line-height: 21.034px;
    margin: 0;
  }

  h2.lbl {
    font-size: 11px;
    text-transform: uppercase;
    margin: 8px 0;
    font-weight: 700;
  }

  h1 {
    font-family: proxima-nova, sans-serif;
    color: #4c4c4b;
    font-weight: 700;
    font-size: 16px;
    line-height: 21.034px;
    margin: 0;
    background: #fbfbfb;
    padding: 16px;
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
  }

  .household-info {
    padding: 16px;
  }

  .tag {
    background: #f7f7f8;
    padding: 4px 8px;
    border-radius: 4px;
    font-family: proxima-nova, sans-serif;
    font-weight: 500;
    color: #4c4c4b;
    font-size: 16px;
    display: inline-block;
    margin-right: 4px;
    margin-bottom: 8px;
  }
</style>

<div class="grid-x grid-margin-x">
  <div class="cell small-12 medium-9">
    <Form>
      {#if value.primary}
      <div class="help">
        {value.firstName} {value.lastName} is the Primary Account holder
      </div>
      {/if}
      <div class="form-group">
        <TextInput
          bind:value="{value.firstName}"
          label="First Name"
          placeholder="First Name"
          disabled="{true}"
          readonly="{true}"
        ></TextInput>
      </div>
      <div class="form-group">
        <TextInput
          bind:value="{value.lastName}"
          label="Last Name"
          placeholder="Last Name"
          disabled="{true}"
          readonly="{true}"
        ></TextInput>
      </div>
      <div class="form-group">
        <TextInput
          bind:value="{value.relationship}"
          label="Relationship"
          placeholder="Relationship"
          disabled="{true}"
          readonly="{true}"
        ></TextInput>
      </div>
      <div class="form-group">
        <TextAreaInput
          bind:value="{value.notes}"
          label="Allergies/Accommodations"
          placeholder="Allergies/Accommodations"
          disabled="{true}"
        ></TextAreaInput>
      </div> 
      <div class="form-group">
        <TextInput
          bind:value="{value.birthYear}"
          label="Birth Year"
          placeholder="Birth Year"
          disabled="{true}"
          readonly="{true}"
        ></TextInput>
      </div>
      <div class="form-group">
        <TextInput
          bind:value="{value.birthMonth}"
          label="Birth Month"
          placeholder="Birth Month"
          disabled="{true}"
          readonly="{true}"
        ></TextInput>
      </div>
      {#if age }
        <div class="form-group">
          <TextInput
            bind:value="{age}"
            label="Age"
            placeholder="Age"
            disabled="{true}"
            readonly="{true}"
          ></TextInput>
        </div>
      {/if}
      <div class="form-group">
        <TextInput
          bind:value="{value.gender}"
          label="Gender"
          placeholder="Gender"
          disabled="{true}"
          readonly="{true}"
        ></TextInput>
      </div> 
      {#if value.ethnicity.length > 0}
      <div class="form-group">
        <label>Race/Ethnicity</label>
        {#each value.ethnicity as ethnicity}
          <span class:tag={true}>{ethnicity}</span>
        {/each}
      </div>
      {:else}
      <div class="form-group">
        <label>Race/Ethnicity</label>
        <span class:tag={true}>Not Answered</span>  
      </div>
      {/if}
      
      
    </Form>
  </div>
  <div class="cell small-12 medium-3">
    <SectionNav>
      <h1>Household Information</h1>
      <div class="household-info">
        <h2 class="lbl">Primary Contact</h2>
        <Link href="{getPrimaryPersonLink()}">
          <h2>
            {value.household.primary.person.firstName}
            {value.household.primary.person.lastName}
          </h2>
        </Link>
        <h2>
          <a href="mailto:{value.household.primary.user.email}"
            >{value.household.primary.user.email}</a
          >
        </h2>
        <h2>{displayPhone()}</h2>
        <h2 class="lbl">Address</h2>
        {#if value.addressIsShared === true}
          <h2>
            {value.household.primary.person.addressLineOne}{#if
            value.household.primary.person.addressLineTwo},
            {value.household.primary.person.addressLineTwo}{/if}<br />{value.household.primary.person.city},
            {value.household.primary.person.state}
            {value.household.primary.person.postal}
          </h2>
        {:else}
          <h2>
            {value.addressLineOne}{#if
            value.addressLineTwo},
            {value.addressLineTwo}{/if}<br />{value.city},
            {value.state}
            {value.postal}
          </h2>
        {/if}
        <h2 class="lbl">Preffered Contact</h2>
        <h2>{value.household.primary.user.notificationPreference}</h2>
      </div>
    </SectionNav>
  </div>
</div>
